import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Select from '../components/ui/Select';
import { useOrder } from '../context/OrderContext';
const ServiceAvailability: React.FC = () => {
  const navigate = useNavigate();
  const {
    deliveryInfo,
    setDeliveryInfo
  } = useOrder();
  const [formData, setFormData] = useState({
    date: 'tomorrow',
    mealType: 'lunch',
    timeSlot: '11:30 - 12:30'
  });
  // Mock delivery dates
  const dateOptions = [{
    value: 'tomorrow',
    label: 'Tomorrow'
  }, {
    value: 'day-after',
    label: 'Day after tomorrow'
  }, {
    value: 'next-week',
    label: 'Next week'
  }];
  // Mock meal types
  const mealTypeOptions = [{
    value: 'breakfast',
    label: 'Breakfast'
  }, {
    value: 'lunch',
    label: 'Lunch'
  }, {
    value: 'dinner',
    label: 'Dinner'
  }];
  // Mock time slots
  const timeSlotOptions = [{
    value: '11:30 - 12:30',
    label: '11:30 - 12:30'
  }, {
    value: '12:30 - 13:30',
    label: '12:30 - 13:30'
  }, {
    value: '13:30 - 14:30',
    label: '13:30 - 14:30'
  }];
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Update delivery info
    setDeliveryInfo({
      ...deliveryInfo!,
      date: formData.date,
      mealType: formData.mealType,
      timeSlot: formData.timeSlot
    });
    // Navigate to food browsing
    navigate('/food');
  };
  const handleGroupOrder = () => {
    navigate('/group-order/create');
  };
  return <div className="max-w-3xl mx-auto" data-id="element-888">
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-889">
        <h1 className="text-xl font-bold mb-6" data-id="element-890">Select Delivery Options</h1>
        {/* Postal code display */}
        <div className="mb-6 p-4 bg-gray-50 rounded-md flex items-start" data-id="element-891">
          <MapPinIcon size={20} className="text-gray-500 mr-3 mt-0.5" data-id="element-892" />
          <div data-id="element-893">
            <div className="flex items-center" data-id="element-894">
              <p className="font-medium" data-id="element-895">
                {deliveryInfo?.postalCode || '123456'}
              </p>
              <button className="ml-3 text-sm text-[#E84118]" onClick={() => navigate('/')} data-id="element-896">
                Edit
              </button>
            </div>
            <p className="text-sm text-gray-500" data-id="element-897">
              Service available in your area
            </p>
          </div>
        </div>
        <form onSubmit={handleSubmit} data-id="element-898">
          {/* Delivery date */}
          <div className="mb-6" data-id="element-899">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-900">
              Delivery Date
            </label>
            <div className="relative" data-id="element-901">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-902">
                <CalendarIcon size={18} className="text-gray-400" data-id="element-903" />
              </div>
              <select name="date" value={formData.date} onChange={handleChange} className="appearance-none pl-10 w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-904">
                {dateOptions.map(option => <option key={option.value} value={option.value} data-id="element-905">
                    {option.label}
                  </option>)}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-906">
                <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-907">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-908" />
                </svg>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-909">
            {/* Meal type */}
            <Select label="Meal Type" name="mealType" options={mealTypeOptions} value={formData.mealType} onChange={handleChange} data-id="element-910" />
            {/* Time slot */}
            <Select label="Estimated Delivery Time Slot" name="timeSlot" options={timeSlotOptions} value={formData.timeSlot} onChange={handleChange} data-id="element-911" />
          </div>
          {/* Cut-off time notice */}
          <div className="mt-4 p-3 bg-red-50 border-l-4 border-red-500 text-red-700" data-id="element-912">
            <div className="flex" data-id="element-913">
              <ClockIcon size={18} className="mr-2" data-id="element-914" />
              <p className="text-sm" data-id="element-915">
                The cut-off time for Lunch order is <strong data-id="element-916">10:00</strong>
              </p>
            </div>
          </div>
          <div className="mt-8 space-y-4" data-id="element-917">
            <Button type="submit" fullWidth size="lg" data-id="element-918">
              Find Food Now
            </Button>
            <Button type="button" variant="outline" fullWidth onClick={handleGroupOrder} data-id="element-919">
              Join Group Order
            </Button>
          </div>
        </form>
      </div>
    </div>;
};
export default ServiceAvailability;